export default [
  {
    title: 'หน้าหลัก',
    route: 'home-dashboard',
    icon: 'HomeIcon',
    resource: 'dashboard',
    action: 'read',
  },
  // {
  //   title: 'สั่งสินค้า',
  //   route: 'customer-orders-order',
  //   icon: 'ShoppingBagIcon',
  // },
  // {
  //   title: 'ตะกร้าของฉัน',
  //   route: 'customer-orders-cart',
  //   icon: 'ShoppingCartIcon',
  // },
  // {
  //   title: 'รายละเอียดการสั่งซื้อ',
  //   route: 'customer-orders-detail',
  //   icon: 'EditIcon',
  // },
  // {
  //   title: 'เชคการส่งของ',
  //   route: 'customer-orders-delivery',
  //   icon: 'CheckCircleIcon',
  // },
]
